<template>
    <v-sheet class="ma-0 py-4 pl-4 pr-2" rounded="lg">
        <v-row class="pa-0 align-center" no-gutters>
            <v-col class="overflow-text-hidden" cols="10">
                <span v-if="sltClcd == '1'" class="font-weight-medium fontOneToTwo">주간 → 야간</span>
                <span v-else-if="sltClcd == '2'" class="font-weight-medium fontOneToTwo">야간 → 주간</span>
                <span class="font-weight-medium fontOneToTwo">&nbsp;인계사항&nbsp;</span>
                <span v-if="sltPk == 0" class="font-weight-medium fontOneToTwo">신규</span>
                <span v-else-if="sltPk > 0" class="font-weight-medium fontOneToTwo">수정</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn
                @click="$emit('offMdl', true)"
                style="margin-top: 2px;" icon>
                <v-icon class="grey006--text" size="30">mdi-close</v-icon>
            </v-btn>
        </v-row>
        <v-divider v-if="sltClcd == '2'" class="white mr-2 mt-2"></v-divider>
        <div v-if="sltClcd == '2'" class="fontDotEight red--text mb-0" style="line-height: 1.1;">
            ※ 작성시간 00(24)시 ~ 06시 자동으로 익일로 계산됩니다.
            <br>
            <div v-if="tkeOvrInf.inspAreaPk > 0">
                ※ 점검일지에서 작성된 인계일지 입니다.<br> 시간, 작성자 수정과 삭제가 불가합니다.
            </div>
        </div>

                
        <v-divider class="mr-2 mt-2"></v-divider>
        <v-row v-if="sltClcd == '2'" class="pa-0 mr-2" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR py-1" cols="3">
                <span class="font-weight-medium">인계일</span>
            </v-col>
            <v-col class="px-3" style="padding-top: 2px;" cols="9">
                <span class="fontDotNine">{{ bscsInfo.tkeDtlDt }}</span>
            </v-col>
        </v-row>
        <v-divider v-if="sltClcd == '2'" class="mr-2"></v-divider>
        <v-row class="pa-0 mr-2" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR py-1" cols="3">
                <span class="font-weight-medium">작성일</span>
            </v-col>
            <v-col class="px-3" style="padding-top: 2px;" cols="9">
                <span class="fontDotNine">{{ bscsInfo.tkeDt }}</span>
            </v-col>
        </v-row>
        <v-divider class="mr-2"></v-divider>
        <v-row class="pa-0 mr-2" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR py-1" cols="3">
                <span class="font-weight-medium">작성시간</span>
            </v-col>
            <v-col class="pl-3 py-1" cols="9">
                <span v-if="tkeOvrInf.inspAreaPk > 0" class="fontDotNine">{{ bscsInfo.wrtTm }}</span>
                <span v-else class="d-inline-block" style="width: 52px;">
                    <CmmTmField v-model="bscsInfo.wrtTm" :required="true"></CmmTmField>
                </span>
            </v-col>
        </v-row>
        <v-divider class="mr-2"></v-divider>
        <v-row class="pa-0 mr-2" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR py-1" cols="3">
                <span class="font-weight-medium">작성자</span>
            </v-col>
            <v-col class="pl-3" style="padding-top: 2px;" cols="9">
                <span v-if="tkeOvrInf.inspAreaPk > 0" class="fontDotNine">{{ bscsInfo.wrtr }}</span>
                <v-btn
                    v-else
                    color="green002" style="padding: 0 10px 2px 8px !important;"
                    @click="onEmpMdl"
                    small>
                    <v-icon class="white--text" style="padding-top: 2px;" size="18">mdi-account-circle-outline</v-icon>
                    <span class="white--text font-weight-bold ml-2" style="padding-top: 1px;">{{ bscsInfo.wrtr }}</span>
                </v-btn>
            </v-col>
        </v-row>
        <v-divider class="mr-2"></v-divider>
        <v-row class="pa-0 mr-2" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR" style="padding-top: 85px;" cols="3">
                <span class="font-weight-medium">인계사항</span>
            </v-col>
            <v-col class="px-3 py-1" cols="9">
                <v-textarea
                    v-model="bscsInfo.cntnt"
                    class="rmrksArea" rows="11"
                    no-resize outlined hide-details dense>
                </v-textarea>
            </v-col>
        </v-row>
        <v-divider class="mr-2"></v-divider>
        <v-divider class="white mb-4"></v-divider>
        <v-row class="pa-0 justify-center" no-gutters>
            <v-btn
                v-if="sltPk > 0 && tkeOvrInf.inspAreaPk == 0"
                :class="[savBtn && tkeOvrInf.inspAreaPk > 0 ? '' : 'grey006 white--text mr-2']"
                :disabled="savBtn && tkeOvrInf.inspAreaPk > 0"
                @click="delTkeOvr"
                outlined rounded small>
                <v-icon class="" size="18">mdi-trash-can-outline</v-icon>
                <span class="fontDotNine mx-1" style="padding-bottom: 1px;">삭제</span>
            </v-btn>
            <v-btn
                :class="[savBtn ? '' : 'blue001 white--text']"
                :disabled="savBtn"
                @click="preTkeOvr"
                outlined rounded small>
                <v-icon class="" size="18">mdi-content-save-outline</v-icon>
                <span class="fontDotNine mx-1" style="padding-bottom: 1px;">저장</span>
            </v-btn>
        </v-row>
    </v-sheet>
</template>

<script>
import { http } from '@/assets/js/baseAxios';

import CmmTmField from '../../cmm/CmmTmField.vue';

export default {
    name: 'HndOvrSavMdl',

    props : {
        sltYMD: { type: String, default: '' },
        sltClcd: { type: Number, default: 0 },
        sltPk: { type: Number, default: 0 },
    },
            
    components: {
        CmmTmField,
    },

    created: function(){
  
    },
    
    mounted: function(){
        //돔 로딩이 끝난 후 작업
        this.$nextTick(function () {
            if(this.sltPk > 0)
                this.getTkeOvr(this.sltPk)
            else {
                this.bscsInfo.wrtr = this.$store.getters.getUserNm
                this.bscsInfo.wrtrMmbrPk = this.$store.getters.getUserPk
                this.bscsInfo.cntnt = '특이사항 없음.'
                this.savBtn = false
            }

            if( this.sltYMD != '' && this.sltClcd != 0 ){
                this.bscsInfo.tkeDt = this.$moment(this.sltYMD, 'YYYYMMDD').format('YYYY.MM.DD')
                this.bscsInfo.tkeDtlDt = this.$moment(this.sltYMD, 'YYYYMMDD').add(1, 'days').format('YYYY.MM.DD')
            }
        })
    },

    computed: {
        getEmpSlctMdl: function () {
            return this.$store.getters.getSlctEmpMdl
        },
    },

    watch:{
        getEmpSlctMdl: function (v) {
            if(v == false){
                this.bscsInfo.wrtr = this.$store.getters.getSlctEmpObj.name
                this.bscsInfo.wrtrMmbrPk = this.$store.getters.getSlctEmpObj.mmbrPk
            }
        },
    },

    methods: { 
        // 인수인계 단건 조회
        getTkeOvr: function (pk){
            let obj = {}
            obj.tkeOvrPk = pk
       
            http.post('empApp/selTkeOvrInfo', obj)
                .then((response) => ( this.tkeOvrRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/selTkeOvrInfo : ' + error))
        },

        tkeOvrRst: function (res) {
            if(res.statusCode == 200){
                this.bscsInfo.cntnt = res.data.cntnt
                this.bscsInfo.tkeDt = this.$moment(res.data.wrtDt, 'YYYYMMDD').format('YYYY.MM.DD')
                this.bscsInfo.tkeDtlDt = this.$moment(res.data.wrtDtlDt, 'YYYYMMDD').format('YYYY.MM.DD')
                this.bscsInfo.wrtTm = res.data.wrtTmHh + ':' + res.data.wrtTmMm
                this.bscsInfo.wrtr = res.data.wrtr
                this.bscsInfo.wrtrMmbrPk = res.data.wrtrMmbrPk

                this.tkeOvrInf.inspAreaPk = res.data.inspAreaPk
                this.tkeOvrInf.inspOrd = res.data.inspOrd
            }

            this.savBtn = false
        },

        // 인수인계 단건 저장
        setTkeOvr: function (obj){
            http.post('empApp/authInsTkeOvr', obj)
                .then((response) => ( this.tkeOvrAcrRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/authInsTkeOvr : ' + error))
        },

        tkeOvrAcrRst: function (res) {
            let obj = {}
            
            if(res.statusCode == 200){
                obj.clr = 'info'
                this.$parent.$parent.$parent.$parent.offHndOvrSavMdl()
            }
            else
                obj.clr = 'error'

            obj.cntn = res.message

            this.savBtn = false
            this.$store.commit('setCmmAlertMdl', true)
            this.$store.commit('setCmmAlertCntn', obj)
        },

        // 인수인계 단건 삭제
        rmTkeOvr: function (pk){
            let obj = {}
            obj.tkeOvrPk = pk

            http.post('empApp/authDelTkeOvr', obj)
                .then((response) => ( this.tkeOvrAcrRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/authDelTkeOvr : ' + error))
        },

        preTkeOvr: function () {
            this.savBtn = true

            let obj = {}
            obj.clr = 'info'

            if(this.bscsInfo.wrtrMmbrPk == 0){
                obj.cntn = '작성자를 선택해주세요.'

                this.$store.commit('setCmmAlertMdl', true)
                this.$store.commit('setCmmAlertCntn', obj)
                return
            }

            if(!/^([01][0-9]|2[0-3]):([0-5][0-9])$/.test(this.bscsInfo.wrtTm)){
                obj.cntn = '작성 시간을 올바르게 입력해주세요.'

                this.$store.commit('setCmmAlertMdl', true)
                this.$store.commit('setCmmAlertCntn', obj)
                return
            }

            let oObj = {}
            oObj.tkeOvrPk = this.sltPk
            oObj.clcd = this.sltClcd
            oObj.wrtDt = this.$moment(this.bscsInfo.tkeDt, 'YYYY.MM.DD').format('YYYYMMDD')
            oObj.wrtTmHh = this.$moment(this.bscsInfo.wrtTm, 'HH:mm').format('HH')
            oObj.wrtTmMm = this.$moment(this.bscsInfo.wrtTm, 'HH:mm').format('mm')
            oObj.cntnt = this.bscsInfo.cntnt
            oObj.wrtr = this.bscsInfo.wrtr
            oObj.wrtrMmbrPk = this.bscsInfo.wrtrMmbrPk
            oObj.inspAreaPk = this.tkeOvrInf.inspAreaPk
            oObj.inspOrd = this.tkeOvrInf.inspOrd

            //console.log(oObj)
            this.setTkeOvr(oObj)
        },

        delTkeOvr: function () {
            this.rmTkeOvr(this.sltPk)
        },

        // 작성자 선택 모달
        onEmpMdl: function () {
            this.$store.commit('setSlctEmpMdl', true)
            this.$store.commit('setSlctEmpDt', this.sltYMD)
        },
    },
    
    data: () => ({
        savBtn: true,
        bscsInfo: {
            tkeDt: '', tkeDtlDt: '', wrtTm: '', wrtr: '', wrtrMmbrPk: 0, cntnt: '',
        },
        tkeOvrInf: {
            inspAreaPk: 0, inspOrd: 0,
        },
    }),
};
</script>